import React, { useEffect } from 'react';

import { FormattedMessage, useIntl } from 'react-intl-next';

import { cssMap, cx } from '@atlaskit/css';
import EmptyState from '@atlaskit/empty-state';
import { Box } from '@atlaskit/primitives/compiled';

import { useProductDependencies } from '../../../controllers/use-product-dependencies';
import { warning } from '../../assets';

import { messages } from './messages';

const styles = cssMap({
	baseStyles: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	configPanelStyles: {
		height: '90%',
	},
	extensionStyles: {
		height: '100%',
	},
});

interface NoExtensionDataProps {
	isConfigPanel?: boolean;
	source?: string;
}

export const NoExtensionData = ({
	source = '',
	isConfigPanel,
}: NoExtensionDataProps): React.JSX.Element => {
	const intl = useIntl();
	const { submitError } = useProductDependencies();

	const extensionSourceName = source?.charAt(0).toUpperCase() + source?.slice(1);

	useEffect(() => {
		const errorMessage = `${extensionSourceName} ${
			isConfigPanel ? 'config panel' : 'extension'
		} failed to render. No parameters.`;

		submitError?.(new Error(errorMessage));
	}, [extensionSourceName, isConfigPanel, submitError]);

	return (
		<Box
			xcss={cx(
				styles.baseStyles,
				isConfigPanel ? styles.configPanelStyles : styles.extensionStyles,
			)}
		>
			<EmptyState
				header={intl.formatMessage(messages.noDataStateHeaderText)}
				description={<FormattedMessage {...messages.noDataStateDescription} />}
				imageUrl={warning}
			/>
		</Box>
	);
};
